import {ModalProps} from "react-bootstrap/Modal";
import {Button, Col, Form, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {IPerson} from "../../store/slicePerson";
import {FormGroup} from "./ModalPersonStyle";
import Select, {MultiValue} from "react-select";
import {Option} from "react-multi-select-component";
import {actions} from "../../store/sliceModal";
import {createOrUpdatePersons} from "../../fetch/RequestBirthday";


export type IPersonProps = {
    person: IPerson
}

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const ModalPerson: FC<ModalProps & IPersonProps> = (props) => {
    const {id, name, eventName, birthdayDate, emails, enableNotification} = props.person
    const {onHide} = props
    const dispatch = useDispatch<AppDispatch>();

    const [personName, setPersonName] = useState<string>('');
    const [event, setEvent] = useState<string>('');
    const [date, setDate] = useState<string>('');
    const [selectOption, setSelectOption] = useState<Option[]>([]);
    const [personEnableNotification, setPersonEnableNotification] = useState<boolean>(enableNotification);


    const [personEmails, setPersonEmails] = useState<MultiValue<Option>>([]);

    useEffect(() => {
        if (id) {
            setPersonName(name)
            setEvent(eventName)
            setDate(birthdayDate)
            setPersonEmails(emails.map(value => {
                return {key: value, label: value} as Option
            }))
            setPersonEnableNotification(enableNotification)
        }
    }, [id, name, eventName, birthdayDate, emails, enableNotification])


    const save = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        const person = {
            id: id,
            name: personName,
            birthdayDate: date,
            emails: personEmails?.map(value => value.label),
            enableNotification: personEnableNotification,
            eventName: event
        } as IPerson
        createOrUpdatePersons(person)
        setPersonName('')
        setEvent('')
        setDate('')
        setPersonEmails([])
        setPersonEnableNotification(false)

        if (onHide) {
            onHide()
        }

    }, [id, personName, event, date, selectOption, personEnableNotification, personEmails])


    const selectChange = useCallback((value: MultiValue<Option>) => {
        const invalidEmail = value.filter((option) => !option.label.match(emailRegex))
        if (invalidEmail.length > 0) {
            dispatch(actions.showError(`Адрес ${invalidEmail.map(option => option.label)} не соответствует email`))
        }
        setPersonEmails(invalidEmail.length > 0 ? personEmails: value)
        setSelectOption([])
    }, [personEmails])

    return (
        <Modal
            {...props}
            size={"lg"}
            //    centered
        >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <FormGroup as={Col}>
                    <Form.Label>Имя</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Имя"
                        value={personName}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => setPersonName(event.target.value)}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Событие</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Событие"
                        value={event}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => setEvent(event.target.value)}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Дата</Form.Label>
                    <Form.Control
                        required
                        type="date"
                        placeholder="Дата"
                        value={date}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => {
                            setDate(event.target.value)
                        }}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Emails</Form.Label>

                    <Select
                        closeMenuOnSelect={false}
                        isMulti
                        onFocus={() => setSelectOption([])}
                        onInputChange={(newValue, actionMeta) => setSelectOption([{label: newValue, value: newValue} as Option])}
                        onChange={(newValue, actionMeta) =>  selectChange(newValue) }
                        options={selectOption ? selectOption : []}
                        value={personEmails}
                        placeholder={"Введите email"}
                        noOptionsMessage={ ({ inputValue }) => null }
                       />
                </FormGroup>
                <Button variant={"outline-success"}
                        onClick={save}
                        style={{marginTop: "20px"}}
                        disabled={event.length === 0 || personName.length === 0 || date.length === 0}
                >
                    {id ? 'Обновить' : 'Создать'}
                </Button>
            </Modal.Body>
        </Modal>
    )
        ;
}

export default memo(ModalPerson)
